import { formatAmount } from '../../common/money';

// eslint-disable-next-line import/prefer-default-export
export const isEmptyHistoryOrFirstOpened = (history) => {
  if (!history || !history.length) return true;
  return !!(history.length === 1 && history[0].opened);
};

const bill = denomination => ({ denomination, isCoin: false });
const coin = (denomination, name, coinsPerRoll) => ({ denomination, name, coinsPerRoll, isCoin: true });

const USD_DENOMINATIONS = [
  coin(1, 'Pennies', 50),
  coin(5, 'Nickels', 40),
  coin(10, 'Dimes', 50),
  coin(25, 'Quarters', 40),
  bill(100),
  bill(200),
  bill(500),
  bill(1000),
  bill(2000),
  bill(5000),
  bill(10000),
];

// can add logic for different currencies later
export const getInitialDenominationValues = () => USD_DENOMINATIONS;

export const getDenominationTotal = item => item.denomination * (item.billsNo || 0);

export const getBillCountsTotal = billCounts =>
  billCounts.reduce((sum, item) => sum + getDenominationTotal(item), 0);

export const getBillCountsDescription = billCounts =>
  billCounts
    .filter(item => !!item.billsNo)
    .map(item => `${item.billsNo} x ${formatAmount(item.denomination, 'USD', 0)}`)
    .join(', ');
